<ion-button
  class="ion-text-uppercase status-btn"
  [color]="'medium'"
  (click)="loadTimeSlot()"
  class="ion-text-uppercase"
>
  <ion-icon
    name="refresh"
    color="light"
    class="ion-float-left icon-padding"
  ></ion-icon>
  RESCHEDULE</ion-button
>
